import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import axios from 'axios';
import {getCsrfToken} from './utils/csrf';
import { InstallCodeMirror } from "codemirror-editor-vue3";


// Set default headers for axios
axios.defaults.headers.common['X-CSRFToken'] = getCsrfToken();

const app = createApp(App);
app.use(InstallCodeMirror);
app.use(router).mount('#app')
